import { render, staticRenderFns } from "./Founders.vue?vue&type=template&id=71a29c93"
import script from "./Founders.vue?vue&type=script&lang=js"
export * from "./Founders.vue?vue&type=script&lang=js"
import style0 from "./Founders.vue?vue&type=style&index=0&id=71a29c93&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports